import { pwDataProps } from '../../components/Organism/MyPage/types/MyPage.types';
import { instance } from '@/shared/lib/clientAxios';

// 회원정보 get
export const getProfileInfo = async () => {
  const response = await instance.get('profile/info');
  if (response.status !== 200) {
    throw new Error('Failed to fetch data');
  }
  return response.data;
};

// 회원탈퇴페이지 정보 get
export const getUseLeaveInfo = async () => {
  const response = await instance.get('profile/leave');
  if (response.status !== 200) {
    throw new Error('Failed to fetch data');
  }
  return response.data;
};

// 회원탈퇴페이지 탈퇴 요청 post
export const postUserPw = async (userPw: string) => {
  const response = await instance.post('/profile/leave', { inputPass: userPw });
  return response.data;
};

// 회원 정보 수정
export const postModifyInfo = async (porps: any) => {
  const data = JSON.parse(porps);
  const response: any = await instance.post('/profile/info', data);
  if (response.status !== 200) {
    throw new Error('Failed to fetch data');
  }
  return response.data;
};

// 비밀번호 변경
export const postChangePw = async (props: pwDataProps) => {
  const response: any = await instance.post('/profile/password', props);
  if (response.status !== 200) {
    throw new Error('Failed to fetch data');
  }
  return response.data;
};

// 휴대폰번호 변경 ( 아이디 변경 )
export const getMyPageChangePhone = async (encodeData: any) => {
  const response: any = await instance.post('/profile/phone', encodeData);
  if (response.status !== 200) {
    throw new Error('Failed to fetch data');
  }
  return response.data;
};

// ==============================
// 승인된 발신번호 리스트 불러오기
// ==============================
export const getCallbackList = async () => {
  const response = await instance.get('/message/getCallbackList');
  localStorage.setItem('callBack', response.data[0].phnId);
  return response.data;
};

// ==============================
// 승인중인 발신번호도 포함한 리스트 불러오기
// ==============================
export const getAllCallbackList = async () => {
  const response = await instance.get('/allCallbackList');
  return response.data;
};

// ==============================
// 최근 한 달 결제 내역 리스트 GET api
// ==============================
export const getRecentPayList = async () => {
  const response = await instance.get('/getPayList');
  return response.data;
};

// ==============================
// 사업자 리스트 GET api
// ==============================
export const getMbrCorpList = async () => {
  const response = await instance.get('/getMbrCorpList');
  return response.data;
};
